/**
 * VCA-Style Drawer Menu + Right Side Panels
 */
(function () {
  'use strict';

  const SELECTORS = {
    drawer: '#vca-drawer',
    toggle: '.mobile-toggle-wrapper',
    close: '[data-vca-close]',
    openPanel: '[data-open-panel]',
    openRightPanel: '[data-open-right-panel]',
    closeRightPanel: '[data-close-right-panel]',
    rightPanel: '[data-right-panel]',
    accountTab: '[data-account-tab]',
    accountForm: '[data-account-form]',
  };

  const CLASSES = {
    open: 'is-open',
    active: 'is-active',
    hasSub: 'has-sub',
    hasThird: 'has-third',
    bodyLock: 'vca-drawer-open',
  };

  let drawer, currentSubPanel, currentThirdPanel;

  function init() {
    drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    // Toggle open (hamburger)
    document.querySelectorAll(SELECTORS.toggle).forEach(function (toggle) {
      toggle.addEventListener('click', handleToggleClick);
      var details = toggle.closest('details');
      if (details) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (details.open) details.removeAttribute('open');
        });
      }
    });

    // Close buttons & overlay
    drawer.querySelectorAll(SELECTORS.close).forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Left panel openers
    drawer.querySelectorAll(SELECTORS.openPanel).forEach(function (btn) {
      btn.addEventListener('click', handlePanelOpen);
    });

    // Back buttons (mobile sub/third panels)
    drawer.querySelectorAll('[data-go-back]').forEach(function (btn) {
      btn.addEventListener('click', handleGoBack);
    });

    // Right panel openers (from drawer footer links AND header icons)
    document.querySelectorAll(SELECTORS.openRightPanel).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var panelId = this.getAttribute('data-open-right-panel');
        openRightPanel(panelId);
      });
    });

    // Right panel close buttons
    document.querySelectorAll(SELECTORS.closeRightPanel).forEach(function (btn) {
      btn.addEventListener('click', closeAllRightPanels);
    });

    // Account tabs
    document.querySelectorAll(SELECTORS.accountTab).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId = this.getAttribute('data-account-tab');
        switchAccountTab(tabId);
      });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (hasOpenRightPanel()) {
          closeAllRightPanels();
        } else if (drawer.classList.contains(CLASSES.open)) {
          closeDrawer();
        }
      }
    });

    // Click outside right panel to close
    document.addEventListener('click', function (e) {
      if (hasOpenRightPanel()) {
        var clickedInsidePanel = e.target.closest('.vca-right-panel');
        var clickedOpener = e.target.closest('[data-open-right-panel]');
        if (!clickedInsidePanel && !clickedOpener) {
          closeAllRightPanels();
        }
      }
    });

      //  ---------------------------custom code for quick close menu when click  // Close drawer on final menu links
      drawer.querySelectorAll(
        '.vca-drawer__link[href], .vca-drawer__sub-link[href], .vca-drawer__sub-title, .vca-drawer__see-all'
      ).forEach(function (link) {
        link.addEventListener('click', function () {
          closeDrawer();
        });
      });
      // -------------------------------------end---custom code for quick close menu when click  -----------------


  }

  /* ---- Left Drawer ---- */
  function handleToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (drawer.classList.contains(CLASSES.open)) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  function openDrawer() {
    closeAllRightPanels();
    drawer.classList.add(CLASSES.open);
    document.body.classList.add(CLASSES.bodyLock);
    resetPanels();
    drawer.setAttribute('aria-hidden', 'false');
    var toggleDetails = document.querySelector('.mobile-toggle-wrapper');
    if (toggleDetails && toggleDetails.tagName === 'DETAILS') {
      toggleDetails.removeAttribute('open');
    }
  }

  function closeDrawer() {
    drawer.classList.remove(CLASSES.open, CLASSES.hasSub, CLASSES.hasThird);
    document.body.classList.remove(CLASSES.bodyLock);
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(resetPanels, 400);
    var toggleDetails = document.querySelector('.mobile-toggle-wrapper');
    if (toggleDetails && toggleDetails.tagName === 'DETAILS') {
      toggleDetails.removeAttribute('open');
    }
  }

  function resetPanels() {
    drawer.querySelectorAll('.' + CLASSES.active).forEach(function (el) {
      el.classList.remove(CLASSES.active);
    });
    drawer.querySelectorAll('[aria-expanded="true"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    currentSubPanel = null;
    currentThirdPanel = null;
    drawer.classList.remove(CLASSES.hasSub, CLASSES.hasThird);
  }

  function handlePanelOpen(e) {
    var btn = e.currentTarget;
    var targetPanelId = btn.getAttribute('data-open-panel');
    var targetPanel = drawer.querySelector('[data-panel="' + targetPanelId + '"]');
    if (!targetPanel) return;
    if (targetPanelId.startsWith('sub-')) {
      openSubPanel(targetPanel, btn);
    } else if (targetPanelId.startsWith('third-')) {
      openThirdPanel(targetPanel, btn);
    }
  }

  function openSubPanel(panel, triggerBtn) {
    if (currentThirdPanel) {
      currentThirdPanel.classList.remove(CLASSES.active);
      currentThirdPanel.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(CLASSES.hasThird);
      drawer.querySelectorAll('.vca-drawer__sub-item.' + CLASSES.active).forEach(function (el) {
        el.classList.remove(CLASSES.active);
      });
    }
    if (currentSubPanel && currentSubPanel !== panel) {
      currentSubPanel.classList.remove(CLASSES.active);
      currentSubPanel.setAttribute('aria-hidden', 'true');
      drawer.querySelectorAll('.vca-drawer__menu-item.' + CLASSES.active).forEach(function (el) {
        el.classList.remove(CLASSES.active);
        var exp = el.querySelector('[aria-expanded]');
        if (exp) exp.setAttribute('aria-expanded', 'false');
      });
    }
    if (currentSubPanel === panel) {
      panel.classList.remove(CLASSES.active);
      panel.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(CLASSES.hasSub);
      triggerBtn.setAttribute('aria-expanded', 'false');
      var menuItem = triggerBtn.closest('.vca-drawer__menu-item');
      if (menuItem) menuItem.classList.remove(CLASSES.active);
      currentSubPanel = null;
      currentThirdPanel = null;
      return;
    }
    panel.classList.add(CLASSES.active);
    panel.setAttribute('aria-hidden', 'false');
    drawer.classList.add(CLASSES.hasSub);
    drawer.classList.remove(CLASSES.hasThird);
    triggerBtn.setAttribute('aria-expanded', 'true');
    var mi = triggerBtn.closest('.vca-drawer__menu-item');
    if (mi) mi.classList.add(CLASSES.active);
    currentSubPanel = panel;
    currentThirdPanel = null;
  }

  function openThirdPanel(panel, triggerBtn) {
    if (currentThirdPanel && currentThirdPanel !== panel) {
      currentThirdPanel.classList.remove(CLASSES.active);
      currentThirdPanel.setAttribute('aria-hidden', 'true');
      drawer.querySelectorAll('.vca-drawer__sub-item.' + CLASSES.active).forEach(function (el) {
        el.classList.remove(CLASSES.active);
        var exp = el.querySelector('[aria-expanded]');
        if (exp) exp.setAttribute('aria-expanded', 'false');
      });
    }
    if (currentThirdPanel === panel) {
      panel.classList.remove(CLASSES.active);
      panel.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(CLASSES.hasThird);
      triggerBtn.setAttribute('aria-expanded', 'false');
      var si = triggerBtn.closest('.vca-drawer__sub-item');
      if (si) si.classList.remove(CLASSES.active);
      currentThirdPanel = null;
      return;
    }
    panel.classList.add(CLASSES.active);
    panel.setAttribute('aria-hidden', 'false');
    drawer.classList.add(CLASSES.hasThird);
    triggerBtn.setAttribute('aria-expanded', 'true');
    var subI = triggerBtn.closest('.vca-drawer__sub-item');
    if (subI) subI.classList.add(CLASSES.active);
    currentThirdPanel = panel;
  }

  /* ---- Go Back (mobile sub/third panels) ---- */
  function handleGoBack(e) {
    var btn = e.currentTarget;
    var panel = btn.closest('.vca-drawer__panel');
    if (!panel) return;

    // If we're in a third-level panel, go back to sub
    if (panel.classList.contains('vca-drawer__panel--third')) {
      panel.classList.remove(CLASSES.active);
      panel.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(CLASSES.hasThird);
      // Remove active state from sub items
      drawer.querySelectorAll('.vca-drawer__sub-item.' + CLASSES.active).forEach(function (el) {
        el.classList.remove(CLASSES.active);
        var exp = el.querySelector('[aria-expanded]');
        if (exp) exp.setAttribute('aria-expanded', 'false');
      });
      currentThirdPanel = null;
    }
    // If we're in a sub-level panel, go back to main
    else if (panel.classList.contains('vca-drawer__panel--sub')) {
      panel.classList.remove(CLASSES.active);
      panel.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(CLASSES.hasSub, CLASSES.hasThird);
      // Remove active state from menu items
      drawer.querySelectorAll('.vca-drawer__menu-item.' + CLASSES.active).forEach(function (el) {
        el.classList.remove(CLASSES.active);
        var exp = el.querySelector('[aria-expanded]');
        if (exp) exp.setAttribute('aria-expanded', 'false');
      });
      currentSubPanel = null;
      currentThirdPanel = null;
    }
  }

  /* ---- Right Panels ---- */
  function openRightPanel(panelId) {
    closeAllRightPanels();
    var panel = document.querySelector('[data-right-panel="' + panelId + '"]');
    if (!panel) return;
    panel.classList.add(CLASSES.open);
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add(CLASSES.bodyLock);
    // Close left drawer if open
    if (drawer && drawer.classList.contains(CLASSES.open)) {
      closeDrawer();
    }
  }

  function closeAllRightPanels() {
    document.querySelectorAll(SELECTORS.rightPanel).forEach(function (panel) {
      panel.classList.remove(CLASSES.open);
      panel.setAttribute('aria-hidden', 'true');
    });
    // Only remove body lock if left drawer is also closed
    if (drawer && !drawer.classList.contains(CLASSES.open)) {
      document.body.classList.remove(CLASSES.bodyLock);
    }
  }

  function hasOpenRightPanel() {
    return document.querySelector('.vca-right-panel.' + CLASSES.open) !== null;
  }

  /* ---- Account Tabs ---- */
  function switchAccountTab(tabId) {
    document.querySelectorAll(SELECTORS.accountTab).forEach(function (tab) {
      tab.classList.toggle(CLASSES.active, tab.getAttribute('data-account-tab') === tabId);
    });
    document.querySelectorAll(SELECTORS.accountForm).forEach(function (form) {
      form.style.display = form.getAttribute('data-account-form') === tabId ? 'block' : 'none';
    });
    // Update panel title
    var panel = document.getElementById('vca-panel-account');
    if (panel) {
      var title = panel.querySelector('.vca-right-panel__title');
      if (title) {
        title.textContent = tabId === 'register' ? 'CREATE AN ACCOUNT' : 'LOG IN';
      }
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();